import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { demandEntry } = stateEnum;

let initialState = {
    detailParams: {},
    isNewEntry: false
};


const demandEntrySlice = createSlice({
    name: demandEntry,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
          },
        resetDetailParams: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
    },
    
});


export const { setNewEntryMode,setDetailParams, resetDetailParams } = demandEntrySlice.actions;
export default demandEntrySlice.reducer;
